var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-name"},[_vm._v("你的好友"+_vm._s(_vm.userInfo && _vm.userInfo.role === 'normal' ? `${_vm.userInfo.nickname}` : ''))]),_c('img',{staticClass:"header-title",style:({ width: `${_vm.width}rem`, height: `${_vm.height}rem` }),attrs:{"src":_vm.titleUrl,"alt":"欢迎来快音"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }